<template>
  <div class="invoice-container">
    <nav class="add-navigation flex flex-wrap">
      <div
        @click="$router.push({ name: 'company-admin-billing-invoices' })"
        class="back-link "
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p class="white_space">Back to Invoices</p>
      </div>
      <div class="buttons-wrapper flex-wrap">
        <div
          @click="$router.push({ name: 'company-admin-billing-invoices' })"
          class="secondary-button  my-2 my-sm-0"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button my-2 my-sm-0">
          <primary-button @click.native="addInvoice"
            >Add Invoice</primary-button
          >
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add Invoice</span>
      <div class="row p-2">
        <div class="col-md-6 col-12">
          <div class="primary-input-container">
            <p class="pimary-input-title">start date</p>
            <div class="primary-select-wrapper">
              <date-picker
                v-model="invoice.invoice_start_date"
                v-validate="'required'"
                name="start date"
                calendar-class="calendar-class"
                format="yyyy-MM-dd"
                wrapper-class="date-wrapper"
                placeholder="DD MM YYYY"
                input-class="date-picker"
              />
              <img
                src="../../../assets/Icon/Arrow/Down.svg"
                class="icon-down"
                alt
              />
            </div>
          </div>
          <div class="help is-danger" v-if="errors.has('start date')">
            {{ errors.first("start date") }}
          </div>
          <div class="primary-input-container">
            <p class="pimary-input-title">end date</p>
            <div class="primary-select-wrapper">
              <date-picker
                v-model="invoice.invoice_end_date"
                v-validate="'required'"
                name="end date"
                calendar-class="calendar-class"
                format="yyyy-MM-dd"
                wrapper-class="date-wrapper"
                placeholder="DD MM YYYY"
                input-class="date-picker"
              />
              <img
                src="../../../assets/Icon/Arrow/Down.svg"
                class="icon-down"
                alt
              />
            </div>
          </div>
          <div class="help is-danger" v-if="errors.has('end date')">
            {{ errors.first("end date") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-5">
          <div class="upload-container">
            <p class="pimary-input-title">Add Attachment</p>
            <app-dropzone
              @fileAdd="fileAdded($event)"
              @remove="fileRemoved($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
    DatePicker: () => import("vuejs-datepicker"),
  },
  data: () => ({
    invoiceError: null,
    invoice: {
      invoice_end_date: null,
      invoice_start_date: null,
      logo_file_uuid: null,
      //company_uuid: null,
    },
    fileId: null,
    file: null,
    enabledUpload: true,
  }),
  created() {},
  methods: {
    fileAdded(file) {
      console.log(file);
      if (file.accepted) {
        this.file = file;
        this.enabledUpload = false;
      }
    },
    fileRemoved() {
      this.file = null;
      this.invoice.logo_file_uuid = null;
    },
    uploadPhoto: async function () {
      let data = new FormData();

      data.append("file", this.file);
      data.append("belongs_to", "invoice.attachment");
      data.append("public", true);

      return await this.$store.dispatch("c", data);
    },
    addInvoice: async function () {
      const valid = await this.$validator.validate();

      if (valid) {
        try {
          if (this.file) {
            const res = await this.uploadPhoto();
            this.invoice.logo_file_uuid = res.object_uuid;
          } else {
            delete this.invoice.logo_file_uuid;
          }

          this.invoice.invoice_start_date = format(
            this.invoice.invoice_start_date,
            "YYYY-MM-DD"
          );
          this.invoice.invoice_end_date = format(
            this.invoice.invoice_end_date,
            "YYYY-MM-DD"
          );

          await this.$store.dispatch("AddInvoice", {
            invoice: this.invoice,
          });

          this.$snotify.success("Invoice has been added.", {
            timeout: 6000,
          });

          this.$router.push({ name: "company-admin-billing-invoices" });
        } catch (err) {
          if (err.errors) {
            this.invoiceError = err.errors[0].invoice
              ? err.errors[0].invoice
              : null;
            setTimeout(() => {
              this.invoiceError = null;
            }, 6000);
          } else if (err.response) {
            this.$snotify.error(
              err.response.data.errors
                ? err.response.data.errors
                : err.response.data.error.message,
              { timeout: 6000 }
            );
          } else {
            this.$snotify.error(err, { timeout: 6000 });
          }
        }
      }
    },
  },
};
</script>

<style  scoped>
@media (max-width: 339px) {
  .secondary-button {
    min-width: 130px!important;
  }
}
</style>

<style lang="scss">
.invoice-container {
  font-family: "Helvetica Neue";
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 130px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    height: 355px;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      height: fit-content;
      .col {
        width: 100%;
        padding-right: 15px;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 40px;
          text-transform: uppercase;
        }
        .upload-photo,
        #dropzone {
          min-height: 240px;
          border-radius: 4px;
          width: 100%;
          .dz-image {
            padding: 5px;
            img {
              height: 150px;
              width: 150px;
            }
          }
        }
      }
    }
  }
  .primary-input-container {
    width: 100%;
    margin-bottom: 15px;
    .pimary-input-title {
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 12px;
      font-weight: 900;
      letter-spacing: 0.21px;
      line-height: 15px;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    .primary-select-wrapper {
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      border: 1px solid #edeef3;
      border-radius: 4px;
      background-color: #ffffff;

      ::placeholder {
        color: #55616e !important;
        opacity: 1;
      }
      .calendar-class {
        width: fit-content !important;
        height: fit-content !important;
        font-family: "Helvetica Neue";
        font-size: 14px;
      }
      .date-wrapper {
        width: 100%;
      }
      .vdp-datepicker {
        div {
          width: 100%;
        }
      }
      .date-picker {
        width: 100%;
        min-height: 40px;
        display: block;
        background: transparent;
        padding-left: 15px;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        border: none;
      }
      select:focus {
        border: 1px solid #51a3f3;
      }
      .icon-down {
        position: absolute;
        left: 100%;
        margin-left: -35px;
      }
    }
  }
}
</style>


